import React, { Component } from 'react';
import { CCOButton, } from '../util/Components.js';
import Link from '../util/Link.js';
import { FaBullhorn, FaCalendar, FaCog, FaRefresh, FaCheckSquareO } from 'react-icons/lib/fa';

class MinistryDirectory extends Component {

  constructor(props) {
    super(props);
    this.state = {
      ministry: null,
      networkAlert: false,
      saved: false,
      baseMinistry: null,
      newStudyTitle: "",
      facebookError: false
    };
  }

  render() {

    return (
      <center>
        <div style={{maxWidth: 300, padding: 10}}>
          <h4 style={{marginBottom: 15}}>Jump to Section</h4>
          <Link to={this.props.ministry.key + "/announcements"} key="announcements"><CCOButton text={<h5 style={{marginTop: 6}}><FaBullhorn size={20} />  Announcements</h5>} /></Link>
          <div style={{height: 15}} />
          <Link to={this.props.ministry.key + "/events"} key="events"><CCOButton text={<h5 style={{marginTop: 6}}><FaCalendar size={20} />  Events</h5>} /></Link>
          <div style={{height: 15}} />
          <Link to={this.props.ministry.key + "/settings"} key="settings"><CCOButton text={<h5 style={{marginTop: 6}}><FaCog size={20} />  Settings</h5>} /></Link>
          <div style={{height: 15}} />
          <Link to={this.props.ministry.key + "/recurring"} key="recurring"><CCOButton text={<h5 style={{marginTop: 6}}><FaRefresh size={20} />  Recurring Events</h5>} /></Link>
          <div style={{height: 15}} />
          {this.props.ministry.type === "service" && <Link to={this.props.ministry.key + "/service"} key="service"><CCOButton text={<h5 style={{marginTop: 6}}><FaCheckSquareO size={20} />  Help & Sign-ups</h5>} /></Link>}
        </div>
      </center>
    );
  }
}

export default MinistryDirectory;



/** WEBPACK FOOTER **
 ** ./src/ministry/MinistryDirectory.js
 **/